"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var AuthActions = _interopRequireWildcard(require("../../actions"));

var events = _interopRequireWildcard(require("../../constants/events"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LegacyAuthProvider = /*#__PURE__*/function (_Component) {
  _inherits(LegacyAuthProvider, _Component);

  function LegacyAuthProvider(props) {
    var _this;

    _classCallCheck(this, LegacyAuthProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LegacyAuthProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "instance", void 0);

    _defineProperty(_assertThisInitialized(_this), "getChildContext", function () {
      return {
        auth: {
          authManager: _this.instance
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      // remove event handlers from AuthManager instance (Auth0Wrapper)
      if (!_lodash.default.isUndefined(_this.instance)) {
        _this.instance.removeListener(events.LOADING_USER, _this.onLoadUser);

        _this.instance.removeListener(events.USER_FOUND, _this.onUserFound);

        _this.instance.removeListener(events.LOAD_USER_ERROR, _this.onLoadUserError);

        _this.instance.removeListener(events.USER_SIGNED_OUT, _this.onUserSignedOut);

        _this.instance.removeListener(events.SESSION_TERMINATED, _this.onSessionTerminated);

        _this.instance = undefined;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onLoadUser", function () {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.loadingUser());
    });

    _defineProperty(_assertThisInitialized(_this), "onUserFound", function (user) {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.userFound(user));
    });

    _defineProperty(_assertThisInitialized(_this), "onLoadUserError", function () {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.loadUserError());
    });

    _defineProperty(_assertThisInitialized(_this), "onUserSignedOut", function () {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.userSignedOut());
    });

    _defineProperty(_assertThisInitialized(_this), "onSessionTerminated", function () {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.sessionTerminated()); // this.instance.signOut(`${this.instance.config.logoutPath}`);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var children = _this.props.children;
      return _react.default.Children.only(children);
    });

    var authManagerInstance = props.authManagerInstance;

    if (!_lodash.default.isUndefined(authManagerInstance)) {
      _this.instance = authManagerInstance; // register event handlers with AuthManager instance (Auth0Wrapper)

      _this.instance.on(events.LOADING_USER, _this.onLoadUser);

      _this.instance.on(events.USER_FOUND, _this.onUserFound);

      _this.instance.on(events.LOAD_USER_ERROR, _this.onLoadUserError);

      _this.instance.on(events.USER_SIGNED_OUT, _this.onUserSignedOut);

      _this.instance.on(events.SESSION_TERMINATED, _this.onSessionTerminated);
    }

    return _this;
  }

  return LegacyAuthProvider;
}(_react.Component);

exports.default = LegacyAuthProvider;

_defineProperty(LegacyAuthProvider, "propTypes", {
  authManagerInstance: _propTypes.default.shape({}).isRequired,
  store: _propTypes.default.shape({
    dispatch: _propTypes.default.func.isRequired
  }).isRequired,
  children: _propTypes.default.node
});

_defineProperty(LegacyAuthProvider, "defaultProps", {
  children: _react.default.createElement("div", null)
});

_defineProperty(LegacyAuthProvider, "childContextTypes", {
  auth: _propTypes.default.shape({
    authManager: _propTypes.default.shape({}).isRequired
  }).isRequired
});